//do weryfikacji czy env.local potrzebny
export const ApiUrls = {
  Auth: `/auth/v2/user/`,
  Common: `/api/v1/plugin/agent/PGIT.Wapro.TranslationPanel/`,
  Retry: `/api/v1/plugin/result/`,
};
